import { Injectable } from '@angular/core';
import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationMessagesService {

  validation_messages: any = {
    'state_id': [
      { type: 'required', message: 'Please select location' },
    ],
    'supplier_id': [
      { type: 'required', message: 'Please select supplier' },
    ],
    'invoice_no': [
      { type: 'required', message: 'Please enter invoice number' },
      { type: 'min', message: 'Invalid invoice number' },
    ],
    'sku_no': [
      { type: 'required', message: 'Please enter sku number' },
      { type: 'min', message: 'Invalid sku number' },
    ],
    'inventory_type_id': [
      { type: 'required', message: 'Please select type' },
    ],
    'purchase_date': [
      { type: 'required', message: 'Please select purchase date' },
    ],
    'case': [
      { type: 'required', message: 'Please enter case' },
      { type: 'min', message: 'Invalid case number' },
    ],
    'case_quantity': [
      { type: 'required', message: 'Please enter case quantity' },
      { type: 'min', message: 'Invalid case quantity' },
    ],
    'price': [
      { type: 'required', message: 'Please enter price' },
      { type: 'min', message: 'Invalid price' },
    ],
    'description': [
      { type: 'required', message: 'Please enter description' },
      { type: 'numericAlpha', message: 'Can only contain letters [A-Z][a-z] and numbers[0-9]' },
    ],
    'StateID': [
      { type: 'required', message: 'Please select location' },
    ],
    'InventoryTypeID': [
      { type: 'required', message: 'Please select type' },
    ],
    'Quantity': [
      { type: 'required', message: 'Please enter quantity' },
      { type: 'min', message: 'Invalid quantity' },
    ],
    Notes: [
      { type: 'required', message: 'Please enter notes' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
      { type: 'numericAlpha', message: 'Can only contain letters [A-Z][a-z] and numbers[0-9]' },
    ],
    'deliveryPartnerName': [
      { type: 'required', message: 'Please enter name' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
      { type: 'numericAlpha', message: 'Can only contain letters [A-Z][a-z] and numbers[0-9]' },
    ],
    Weight: [
      { type: 'required', message: 'Please enter Weight' },
      { type: 'min', message: 'Invalid Weight' },
    ],
    Height: [
      { type: 'required', message: 'Please enter Height' },
      { type: 'min', message: 'Invalid Height' },
    ],
    Width: [
      { type: 'required', message: 'Please enter Width' },
      { type: 'min', message: 'Invalid Width' },
    ],
    Length: [
      { type: 'required', message: 'Please enter Length' },
      { type: 'min', message: 'Invalid Length' },
    ],
    NotifyUsersBy: [
      { type: 'minLengthByKey', message: 'Select atleast one option' },
    ],

    'phone': [
      { type: 'required', message: 'Please enter mobile number' },
      { type: 'invalidPhone', message: 'Invalid phone number' },
    ],
    'via': [
      { type: 'required', message: 'Select atleast one option' },
    ],
    'otp': [
      { type: 'required', message: 'Please enter OTP' },
    ],
    firstName: [
      { type: 'required', message: 'Please enter first name' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    lastName: [
      { type: 'required', message: 'Please enter last name' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    email: [
      { type: 'required', message: 'Email Address required.' },
      { type: 'invalidEmail', message: 'Invalid Email address.' },
    ],
    dob: [
      { type: 'required', message: 'Please enter date of birth' },
    ],
    password: [
      { type: 'required', message: 'Please enter password' },
      { type: 'minlength', message: 'Enter atleast six characters' },
    ],
    'password_confirmation': [
      { type: 'mismatchedPasswords', message: 'Password does not match' },
    ],
    insurance_provider: [
      { type: 'required', message: 'Please enter insurance provider' },
    ],
    contract_plan_number: [
      { type: 'required', message: 'Please enter contract/plan number' },
    ],
    primary_card_holder: [
      { type: 'required', message: 'Please enter primary card holder name' },
    ],
    contact_no: [
      { type: 'required', message: 'Invalid phone number' },
      { type: 'invalidPhone', message: 'Invalid phone number' },
    ],
    curr_pharmacy_title: [
      { type: 'required', message: 'Enter pharmacy name' },
    ],
    curr_pharmacy_phone: [
      { type: 'required', message: 'Invalid pharmacy phone number' },
      { type: 'invalidPhone', message: 'Invalid phone number' },
    ],
    medication: [
      { type: 'minLength', message: 'Select medicine please' },
    ],
    time: [
      { type: 'required', message: 'Please select timings' },
      { type: 'minLength', message: 'Please select timings' },
    ],
    currentPassword: [
      { type: 'required', message: 'Enter current password' },
    ],
    newPassword: [
      { type: 'required', message: 'Enter new password' },
      { type: 'minlength', message: 'Password must be atleast 6 characters' },
    ],
    'confirmNewPassword': [
      { type: 'mismatchedPasswords', message: 'Password does not match' },
    ],
    title: [
      { type: 'required', message: 'You cant leave title empty' },
      { type: 'numericAlpha', message: 'Can only contain letters [A-Z][a-z] and numbers[0-9]' },
    ],
    text: [
      { type: 'required', message: 'You cant leave description empty' },
    ],
    date: [
      { type: 'required', message: 'Please select date' },
      { type: 'dateGreaterThanCurrentDate', message: 'Select the valid value, You cannot select past date.' },
    ],
    city: [
      { type: 'required', message: 'Please enter city' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    address: [
      { type: 'required', message: 'Please enter address' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    ext: [
      { type: 'required', message: 'Please enter Ext' },
    ],
    health_card: [
      { type: 'required', message: 'Please enter Health Card Number' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
      { type: 'minlength', message: 'Invalid Health Card Number' },
    ],
    postal_code: [
      { type: 'required', message: 'Please enter Postal Code' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    reason_for_visit: [
      { type: 'required', message: 'This field is required' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    RejectedReasonID: [
      { type: 'required', message: 'This field is required' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    RenewRefillStatusType: [
      { type: 'required', message: 'This field is required' },
      { type: 'spaceValidator', message: 'Cannot be started with space.' },
    ],
    reason: [
      { type: 'required', message: 'Please select reason' },
    ],
  }
  validateAllFormFields(formGroup: FormGroup) {
    if (formGroup.errors && formGroup instanceof FormGroup) {
      formGroup.markAsTouched({ onlySelf: true });
    }
    Object.keys(formGroup.controls).forEach(field => {
      let control = formGroup.get(field);
      if (control?.errors && control instanceof FormArray) {
        control.markAsTouched({ onlySelf: true });
      }
      if (control?.value && control?.value.length > 0 && control?.value instanceof Array) {
        this.validateArray((control as FormArray));
      }
      if (control?.value && control?.value.length == 0 && control?.value instanceof Array) {
        control?.markAsTouched({ onlySelf: true });
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  validateArray(formGroup: FormArray) {
    if (formGroup.controls) {
      for (let index = 0; index < formGroup.controls.length; index++) {
        this.validateArrayFields(formGroup.controls[index] as FormArray);
      }
    }
  }
  validateArrayFields(formGroup: FormArray) {
    if (formGroup.controls) {
      Object.keys(formGroup.controls).forEach(fields => {
        const controls = formGroup.get(fields);
        if (controls instanceof FormControl) {
          controls.markAllAsTouched();
        }
        if (controls instanceof FormArray) {
          controls.markAllAsTouched();
        }
      });
    }
    else {
      let control = formGroup;
      control.markAllAsTouched();
    }
  }
  removeFormControlError(control: AbstractControl, errorName: string) {
    if (control?.errors && control?.errors[errorName]) {
      delete control.errors[errorName];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }

  avoidFirstSpace = (e: any) => {
    if (e.code == 'Space' && e.target.value.length == 0) {
      return false
    }
    // First char must not be a space.
    else if (e.target.value[0] == ' ') {
      e.target.value = e.target.value.replace(/\ /, '')
    }
    return true;
  };

  regexForSecurity(string: any) {

    if (string != null && string != undefined) {
      let regexString = JSON.stringify(string)
        .replace(/^(<([^>]+)>)/g, "").replace(/javascript/g, "")
        .replace(/.xss/g, "").replace(/>/g, "").replace(/</g, "")
        .replace(/jquery/g, "").replace(/json/g, "").replace(/onmouseover/g, "")
        .replace(/onload/g, "").replace(/onclick/g, "")
        .replace(/ondblclick/g, "").replace(/onfocusout/g, "").replace(/appendChild/g, "")
        .replace(/HttpRequest/g, "").replace(/body./g, "").replace(/.body/g, "")
        .replace(/php/g, "").replace(/cookies/g, "").replace(/FSCommand/g, "")
        .replace(/base64/g, "").replace(/onfocusout/g, "").replace(/onkeypress/g, "")
        .replace(/keyframes/g, "").replace(/malware/g, "").replace(/formData/g, "")
        .replace(/onActivate/g, "").replace(/stylesheet/g, "").replace(/alert/g, "")
        .replace(/css/g, "")
        //.replace(/css/g, "").replace(/eval/g, "")
      return JSON.parse(regexString)
    }
  }
}
